import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend, LineChart, Line
} from 'recharts';

interface ChartProps {
  type: 'bar' | 'pie' | 'line';
  data: any[];
  dataKey: string;
  nameKey?: string;
  title?: string;
  color?: string;
  colors?: string[];
  height?: number;
  xKey?: string;
  yKey?: string;
  lineKey?: string;
}

const COLORS = [
  '#6366f1', '#10b981', '#f59e42', '#ef4444', '#3b82f6', '#a21caf', '#fbbf24', '#14b8a6', '#eab308', '#f472b6'
];

export const StatisticsChart: React.FC<ChartProps> = ({
  type,
  data,
  dataKey,
  nameKey,
  title,
  color = '#6366f1',
  colors = COLORS,
  height = 320,
  xKey,
  yKey,
  lineKey
}) => {
  let chartContent = null;
  if (type === 'bar' && xKey) {
    chartContent = (
      <BarChart data={data} margin={{ top: 16, right: 24, left: 0, bottom: 8 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={xKey} tick={{ fontSize: 12 }} />
        <YAxis tick={{ fontSize: 12 }} />
        <Tooltip />
        <Bar dataKey={dataKey} fill={color} radius={[8, 8, 0, 0]} />
      </BarChart>
    );
  } else if (type === 'pie' && nameKey) {
    chartContent = (
      <PieChart>
        <Tooltip />
        <Legend />
        <Pie
          data={data}
          dataKey={dataKey}
          nameKey={nameKey}
          cx="50%"
          cy="50%"
          outerRadius={90}
          fill={color}
          label
        >
          {data.map((entry, idx) => (
            <Cell key={`cell-${idx}`} fill={colors[idx % colors.length]} />
          ))}
        </Pie>
      </PieChart>
    );
  } else if (type === 'line' && xKey && lineKey) {
    chartContent = (
      <LineChart data={data} margin={{ top: 16, right: 24, left: 0, bottom: 8 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={xKey} tick={{ fontSize: 12 }} />
        <YAxis tick={{ fontSize: 12 }} />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey={lineKey} stroke={color} strokeWidth={3} dot={{ r: 4 }} />
      </LineChart>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow p-4 flex flex-col items-center w-full">
      {title && <h3 className="text-lg font-semibold text-gray-800 mb-4">{title}</h3>}
      <ResponsiveContainer width="100%" height={height}>
        {chartContent || <div />}
      </ResponsiveContainer>
    </div>
  );
};

export default StatisticsChart; 